var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPwShowDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C4.1268 0 0 5.7984 0 6.72C0 7.6392 4.1268 13.44 12 13.44C19.872 13.44 24 7.6392 24 6.72C24 5.7984 19.872 0 12 0ZM12 11.8884C9.054 11.8884 6.666 9.5748 6.666 6.72C6.666 3.8652 9.054 1.5492 12 1.5492C14.946 1.5492 17.3328 3.8652 17.3328 6.72C17.3328 9.5748 14.946 11.8884 12 11.8884ZM12 6.72C11.5116 6.1836 12.7956 4.1352 12 4.1352C10.5264 4.1352 9.3324 5.2932 9.3324 6.72C9.3324 8.1468 10.5264 9.3048 12 9.3048C13.4724 9.3048 14.6676 8.1468 14.6676 6.72C14.6676 6.0636 12.4152 7.1748 12 6.72Z",
    fill: "#00284E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwShowDark);
export default __webpack_public_path__ + "static/media/pwShowDark.3830c8bf8554163cbffb1b4c08176b0f.svg";
export { ForwardRef as ReactComponent };